import Blockly from "blockly";
import Schema from "../schema";

export const menu = {
  name: (<div className="text"><u>A</u>pply effect on all enemies</div>),
  trigger: 'a',
  children: {
    'enemy_burn': {
      name: (<div className="text"><u>B</u>urn</div>),
      trigger: 'b',
    },
    'enemy_charm': {
      name: (<div className="text"><u>C</u>harm</div>),
      trigger: 'c',
    },
    'enemy_confuse': {
      name: (<div className="text">C<u>o</u>nfuse</div>),
      trigger: 'o'
    },
    'enemy_duplicate': {
      name: (<div className="text"><u>D</u>uplicate</div>),
      trigger: 'd'
    },
    'enemy_fear': {
      name: (<div className="text"><u>F</u>ear</div>),
      trigger: 'f'
    },
    'enemy_freeze': {
      name: (<div className="text">Free<u>z</u>e</div>),
      trigger: 'z'
    },
    'enemy_midas': {
      name: (<div className="text"><u>G</u>old freeze</div>),
      trigger: 'g'
    },
    'enemy_heal': {
      name: (<div className="text"><u>H</u>eal</div>),
      trigger: 'h'
    },
    /*
    'enemy_invisible': {
      name: (<div className="text"><u>I</u>nvisible</div>),
      trigger: 'i'
    },
    */
    'enemy_poison': {
      name: (<div className="text"><u>P</u>oison</div>),
      trigger: 'p'
    },
    'enemy_shrink': {
      name: (<div className="text"><u>S</u>hrink</div>),
      trigger: 's'
    },
    'enemy_slow': {
      name: (<div className="text">S<u>l</u>ow</div>),
      trigger: 'l'
    }
  }
}

// Schema used for all enemy status effects:
Schema.registerAction('enemy_apply_status', {
  "if": {
    "properties": {
      "action": {
        "const": "enemy_apply_status"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "status": {
            "enum": [
              "burn",
              "charm",
              "confuse",
              "duplicate",
              "fear",
              "freeze",
              "midas",
              "heal",
              "invisible",
              "kill",
              "poison",
              "shrink",
              "slow",
            ],
          },
          "from_param": {
            "type": "string",
            "minLength": 1,
          },
          "duration": {
            "type": "number",
            "minimum": 1,
            "maximum": 30,
          },
          "hitpoints": {
            "type": "number",
            "minimum": 0,
            "maximum": 10000,
          },
          "speed": {
            "type": "number",
            "minimum": 0,
            "maximum": 100,
          },
          "ignore": {
            "type": "boolean",
          }
        },
        "anyOf": [
          {
            "if": {
              "properties": {
                "status": {
                  "const": "heal"
                }
              }
            },
            "then": {
              "required": [
                "hitpoints"
              ],
            },
          },
          {
            "if": {
              "properties": {
                "status": {
                  "const": "slow"
                }
              }
            },
            "then": {
              "required": [
                "speed"
              ]
            },
          }
        ],
        "oneOf": [
          {
            "required": [
              "status"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "required": [
          "status"
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params",
    ],
  }
});

/* ****************************************************************************************************************
 * Apply burn effect to all enemies in the current room
 ******************************************************************************************************************/
Blockly.Blocks['enemy_burn'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Burn enemies in the room for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Apply the burn effect to all enemies in the current room for the specified duration.');
  }
};

Blockly.JSON['enemy_burn'] = (block) => {
  let params  = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    params['status'] = 'burn';
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};

/* ****************************************************************************************************************
 * Apply charm effect to all enemies in the current room
 ******************************************************************************************************************/
Blockly.Blocks['enemy_charm'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Charm enemies in the room for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Apply the charm effect to all enemies in the current room for the specified duration.');
  },
};

Blockly.JSON['enemy_charm'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    params['status'] = 'charm';
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};

/* ****************************************************************************************************************
 * Apply confuse effect to all enemies in the current room
 ******************************************************************************************************************/
Blockly.Blocks['enemy_confuse'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Confuse enemies in the room for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds,')
      .appendField(
        new Blockly.FieldDropdown([
          ['including', '0'],
          ['excluding', '1'],
        ]),
        'IgnoreBosses'
      )
      .appendField('bosses');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Apply the confuse effect to all enemies (and optionally bosses) in the current room for the specified duration.');
  },
};

Blockly.JSON['enemy_confuse'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  let ignore = Boolean(parseInt(block.getFieldValue('IgnoreBosses'), 10));
  if (params) {
    params['status'] = 'confuse';
    params['ignore'] = ignore;
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};

/* ****************************************************************************************************************
 * Duplicate all enemies in the current room
 ******************************************************************************************************************/
Blockly.Blocks['enemy_duplicate'] = {
  init: function () {
    this.appendDummyInput('stat')
      .appendField('Duplicate the enemies in the room')

    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Duplicate all enemies in the current room.');
  }
};

Blockly.JSON['enemy_duplicate'] = (block) => {
  return {
    action: 'enemy_apply_status',
    params: {
      "status": "duplicate",
    }
  };
};

/* ****************************************************************************************************************
 * Apply fear effect to all enemies in the current room
 ******************************************************************************************************************/
Blockly.Blocks['enemy_fear'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Fear enemies in the room for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds')

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Apply the fear effect to all enemies in the current room for the specified duration.');
  },
};

Blockly.JSON['enemy_fear'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    params['status'] = 'fear';
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};

/* ****************************************************************************************************************
 * Apply freeze effect to all enemies in the current room
 ******************************************************************************************************************/
Blockly.Blocks['enemy_freeze'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Freeze enemies in the room for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds')

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Apply the freeze effect to all enemies in the current room for the specified duration.');
  },
};

Blockly.JSON['enemy_freeze'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    params['status'] = 'freeze';
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};

/* ****************************************************************************************************************
 * Heal all enemies in the current room
 ******************************************************************************************************************/
Blockly.Blocks['enemy_heal'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setMinimum(1);
    shadow.setMaximum(10000);
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Heal enemies in the room up to')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('hit points')

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Heal all enemies in the current room up to the specified ammount of hit points.');
  },
};

Blockly.JSON['enemy_heal'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    params['status'] = 'heal';
    if (params.hasOwnProperty('value')) {
      params['hitpoints'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};

/* ****************************************************************************************************************
 * Freeze all enemies in the current room as gold
 ******************************************************************************************************************/
Blockly.Blocks['enemy_midas'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Turn enemies in the room gold for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds')

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Turn all enemies in the current room gold for the specified duration.');
  },
};

Blockly.JSON['enemy_midas'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    params['status'] = 'midas';
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};

/* ****************************************************************************************************************
 * Makes all enemies in the current room invisible
 ******************************************************************************************************************/
Blockly.Blocks['enemy_invisible'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Turn enemies in the room invisible for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds')

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Makes all enemies in the current room invisible for the specified duration.');
  },
};

Blockly.JSON['enemy_invisible'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    params['status'] = 'invisible';
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};

/* ****************************************************************************************************************
 * Poison all enemies in the current room
 ******************************************************************************************************************/
Blockly.Blocks['enemy_poison'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Poison enemies in the room for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds')

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Apply the poison effect to all enemies in the current room for the specified duration.');
  },
};

Blockly.JSON['enemy_poison'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    params['status'] = 'poison';
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};

/* ****************************************************************************************************************
 * Shrink all enemies in the current room
 ******************************************************************************************************************/
Blockly.Blocks['enemy_shrink'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Shrink enemies in the room for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds')

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Shrink all enemies in the current room for the specified duration.');
  },
};

Blockly.JSON['enemy_shrink'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    params['status'] = 'shrink';
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};

/* ****************************************************************************************************************
 * Slow all enemies in the current room
 ******************************************************************************************************************/
Blockly.Blocks['enemy_slow'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    let shadow2 = this.workspace.newBlock('input_number');
    shadow2.setMinimum(0);
    shadow2.setMaximum(100);
    shadow2.setShadow(true);
    shadow2.initSvg();
    shadow2.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Slow enemies in the room for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds, at')
    this.appendValueInput('Input2')
      .setCheck(['number'])
      .connection
      .connect(shadow2.outputConnection)
    this.appendDummyInput('trailing2')
      .appendField('% of their speed')

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Slow all enemies in the current room for the specified duration at the specified speed percentage.');
  },
};

Blockly.JSON['enemy_slow'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  let params2 = Blockly.JSON.valueToCode(block, 'Input2', Blockly.JSON.ORDER_ATOMIC);

  if (params) {
    params['status'] = 'slow';
    params['speed'] = params2.value
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'enemy_apply_status',
      params
    }
  } else return;
};
